/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import { use } from 'fierry/react';

import { useArg } from 'solis/navigation';
import Galaxy from 'solis/application/galaxy';
import Time from 'solis/time';

import Title from 'solis/react/element/title';
import Text from 'solis/react/primitive/text';

import GalaxyDiscovery from 'solis/claude/logic/galaxy/discovery';

import Args from 'solis/claude/action/args';
import BoardTile from 'solis/claude/tile/board';


const Tiles = ({ entries, selectedID }) =>
(
  <Flex wrap = 'wrap' gap = '5'>
    {entries.map(({ board }) => <BoardTile key = {board.cass.id} board = {board} selected = {board.cass.id === selectedID} />)}
  </Flex>
);


export default () =>
{
  const galaxy = use(Galaxy);
  const now = use(Time);

  const selected = useArg(Args.DeployBoard);

  const entries = new GalaxyDiscovery(galaxy).getOpenBoardsByRemainingAuthority(galaxy.getCurrentAccount(), now);

  const selectedID = entries.some(entry => entry.board.cass.id === selected) ? selected : entries[0]?.board.cass.id;

  return (
    <Flex direction = 'column' gap = '3' p = '5'>
      <Title>Open boards</Title>
      {entries.length > 0 ? <Tiles entries = {entries} selectedID = {selectedID} /> : <Text.Note>No open boards to attack. Create your own and let them come to you.</Text.Note>}
    </Flex>
  );
};
